<div class="header">
  <img [src]="imgPath" alt="Header Image" class="img-fluid">
  <div class="overlay">
    <h1>{{title}}
    </h1>
    <app-bread-crumbs [isDark]="false" [breadcrumbs]="breadcrumbs"></app-bread-crumbs>
  </div>
</div>
